import { render, staticRenderFns } from "./ListDetailCollapseFamilies.vue?vue&type=template&id=005c317e"
import script from "./ListDetailCollapseFamilies.vue?vue&type=script&lang=js"
export * from "./ListDetailCollapseFamilies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('005c317e')) {
      api.createRecord('005c317e', component.options)
    } else {
      api.reload('005c317e', component.options)
    }
    module.hot.accept("./ListDetailCollapseFamilies.vue?vue&type=template&id=005c317e", function () {
      api.rerender('005c317e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/services/components/ListDetailCollapseFamilies.vue"
export default component.exports